import React from "react";

export default function TspFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="tsp-footer">
      <p>{year} Brihad Mridanga Platform - TSP Management Application.</p>
    </footer>
  );
}
